import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { FaPause, FaPlay } from "react-icons/fa";

const Videos = () => {
  const videoRefs = useRef<HTMLVideoElement[]>([]);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handlePlayPause = (index: number) => {
    videoRefs.current.forEach((video, i) => {
      if (video) {
        if (i === index) {
          if (video.paused) {
            video.play();
            setActiveIndex(i);
          } else {
            video.pause();
            setActiveIndex(null);
          }
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  };

  const videos = [
    "/videos/specter1.mp4",
    "/videos/specter2.mp4",
    "/videos/specter3.mp4",
  ];

  return (
    <section className="bg-white py-8 md:py-12 lg:py-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <Swiper
          modules={[Navigation, Pagination]}
          dir="ltr"
          init={true}
          navigation={{
            enabled: !isMobile,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          spaceBetween={0}
          slidesPerView={1}
          initialSlide={0}
          centeredSlides={false}
          className="w-full relative rounded-lg md:rounded-xl lg:rounded-20 overflow-hidden shadow-lg"
          style={{
            height: isMobile ? "60vh" : "70vh",
            minHeight: isMobile ? "300px" : "400px",
            maxHeight: isMobile ? "500px" : "600px",
            direction: "ltr",
          }}
          wrapperTag="div"
        >
          {videos.map((src, idx) => (
            <SwiperSlide
              key={idx}
              style={{
                width: "100%",
                flexShrink: 0,
              }}
              className="!w-full !h-full flex-shrink-0"
            >
              <div className="relative w-full h-full flex items-center justify-center bg-black overflow-hidden">
                <video
                  ref={(el) => {
                    if (el) videoRefs.current[idx] = el;
                  }}
                  src={src}
                  className="w-full h-full object-cover"
                  controls={false}
                  loop
                  playsInline
                />
                <button
                  onClick={() => handlePlayPause(idx)}
                  className="absolute right-2 bottom-2 md:right-4 md:bottom-4 flex items-center justify-center bg-black/50 hover:bg-black/70 active:bg-black/80 transition-all duration-200 p-2 md:p-3 lg:p-3.5 rounded-full backdrop-blur-sm border border-white/20"
                  aria-label={
                    activeIndex === idx ? "Pause video" : "Play video"
                  }
                >
                  {activeIndex === idx ? (
                    <FaPause className="text-sm md:text-lg lg:text-xl text-white" />
                  ) : (
                    <FaPlay className="text-sm md:text-lg lg:text-xl text-white ml-0.5" />
                  )}
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Videos;
